import { render, staticRenderFns } from "./ClienteProveedorGrid.vue?vue&type=template&id=6a4df532&"
import script from "./ClienteProveedorGrid.vue?vue&type=script&lang=ts&"
export * from "./ClienteProveedorGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports